const pixelUnit = (n: number) => `calc(8px * ${n})`;

export const buildPixelSize = (size: global.Sizes | global.Sizes[] | undefined) => {
    if (size) {
        if (size instanceof Array) {
            return size.map((e) => getSize(e)).join(' ');
        } else {
            return getSize(size);
        }
    }

    return '0';
};

function getSize(size: string | global.Sizes[]) {
    switch (size) {
        default:
        case 'none':
            return '0';

        case 'xxSmall':
            return pixelUnit(0.5);
        case 'xSmall':
            return pixelUnit(1);
        case 'small':
            return pixelUnit(2);
        case 'medium':
            return pixelUnit(3);
        case 'large':
            return pixelUnit(5);
        case 'xLarge':
            return pixelUnit(7);
        case 'xxLarge':
            return pixelUnit(9);
    }
}
